// Figma: no frame provided yet — built using the established design system per the
// "extrapolate" decision.
// LOGIC PORTED from LC2's ReviewRow.js (commons/components/HomeTabs/StakeSay/
// ReviewsTable/ReviewRow.js): same 300-char truncation + "See more/less" expand, same
// anonymous-name handling, same community/campaign chip (via `openItem`/`entities`).
// SIMPLIFIED / NOT PORTED: the stake-admin-only "Visible to client" toggle (an
// `editReview` mutation) — this pass is read-only, see StakeSaySection.js's header
// comment.
import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {Box, Button, Rating, Stack, Typography} from '@mui/material';

import {getOpenItem} from '../../../app/store/reducers/menu';
import {getCampaigns, getCommunities} from '../../../app/store/reducers/entities';
import Badge from '../components/Badge';

const ReviewCard = ({review}) => {
    const openItem = useSelector(getOpenItem);
    const communities = useSelector(getCommunities);
    const campaigns = useSelector(getCampaigns);

    const [expanded, setExpanded] = useState(false);
    const text = review.text || '';
    const isLong = text.length > 300;
    const displayText = expanded || !isLong ? text : `${text.slice(0, 300)}...`;
    const displayName = review.is_anonymous ? 'Anonymous' : review.name;

    let chipLabel = null;
    if (openItem === 'portfolio' && review.property_sfid) {
        chipLabel = communities.find((c) => c.sfid === review.property_sfid)?.name;
    } else if (openItem === 'communities' && review.campaign_sfid) {
        chipLabel = campaigns.find((c) => c.id === review.campaign_sfid)?.name;
    }

    return (
        <Stack spacing={1} sx={{py: 2}}>
            <Typography variant="subtitle1" fontWeight={600}>
                {displayName}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
                <Rating value={review.rating} precision={0.1} readOnly size="small" />
                <Typography variant="body2" color="text.secondary">
                    {review.date}
                </Typography>
            </Stack>
            {chipLabel && (
                <Box>
                    <Badge label={chipLabel} variant="neutral" />
                </Box>
            )}
            <Typography variant="body2" sx={{whiteSpace: 'pre-wrap'}}>
                {displayText}
            </Typography>
            {isLong && (
                <Box>
                    <Button size="small" sx={{px: 0}} onClick={() => setExpanded((prev) => !prev)}>
                        {expanded ? 'See Less' : 'See More'}
                    </Button>
                </Box>
            )}
        </Stack>
    );
};

export default ReviewCard;
